import React from "react";
import Step1 from "../steps/section-2/step-1";
import Step2 from "../steps/section-2/step-2";
import Step3 from "../steps/section-2/step-3";
import Step4 from "../steps/section-2/step-4";
import Step5 from "../steps/section-2/step-5";
import Step6 from "../steps/section-2/step-6";
import Step7 from "../steps/section-2/step-7";
import Step8 from "../steps/section-2/step-8";
import Step9 from "../steps/section-2/step-9";

function TeamReportsSection2({
  step = 1,
  team_grade = 0,
  rank_name = "",
  data = {},
  teams = {},
  share_price = 0,
  current_year = 1,
  competition_metrics = {}
}) {
  if (step === 1) {
    return <Step1 team_grade={team_grade} rank_name={rank_name} />;
  }

  if (step === 2) {
    return <Step2 current_year={current_year} />;
  }

  if (step === 3) {
    if (current_year <= 4) {
      return <Step7 teams={teams} competition_metrics={competition_metrics} />;
    }

    return <Step3 data={data} teams={teams} share_price={share_price} />;
  }

  if (step === 4) {
    if (current_year <= 4) {
      return <Step8 teams={teams} competition_metrics={competition_metrics} />;
    }

    return <Step4 data={data} teams={teams} />;
  }

  if (step === 5) {
    if (current_year <= 4) {
      return <Step9 teams={teams} competition_metrics={competition_metrics} />;
    }

    return <Step5 data={data} teams={teams} />;
  }

  if (step === 6) {
    if (current_year <= 4) {
      return <Step3 data={data} teams={teams} share_price={share_price} />;
    }

    return <Step6 data={data} teams={teams} />;
  }

  return null;
}

export default TeamReportsSection2;



// WEBPACK FOOTER //
// ./src/components/team-reports/sections/section-2.js